import React, { useState } from "react";
import { Box, Grid, Typography, Button, Container } from "@mui/material";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import Background from "../../components/Background";
import Sidebar from "../../components/Sidebar";
import Mobilesidebar from "../../components/Mobilesidebar";
import MenteeHeader from "../../components/MenteeHeader";
import Helpimage from "../../assets/images/helpandsupportimage.jpg";
import messageicon from "../../assets/images/Message.png";
import questionIcon from "../../assets/images/sidebar-icon/message-question-active.svg";
import DashboardFooter from "../../components/Footer";

function HelpandSupport() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <>
      <Background>
        <MenteeHeader
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
        />
        <Box
          sx={{
            padding: {
              xs: "10px 0 20px",
              sm: "10px 0 20px",
              md: "10px 0 20px",
              lg: "10px 0 20px",
              xl: "20px 0 30px",
            },
          }}
        >
          <Container maxWidth="xl">
            <Grid container spacing={{ lg: 3, sm: 2, xs: 2 }}>
              <Grid item xs={12} sm={4} md={3} lg={3}>
                <Mobilesidebar />
                <Sidebar />
              </Grid>
              {/* Main Content Section */}
              <Grid item xs={12} sm={8} md={9} lg={9}>
                <Box
                  sx={{
                    height: "100%",
                    overflow: "auto", // Enable scrolling if content exceeds the height
                    padding: "24px",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #E0E0E0",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "1.1rem",
                      marginBottom: "16px",
                      color: "#2A4876",
                      textAlign: "center",
                    }}
                  >
                    How can we help you today?
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: { xs: "16px", sm: "24px" },
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        display: { xs: "none", md: "flex" },
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Helpimage}
                        alt="Help illustration"
                        style={{
                          width: "100%",
                          maxHeight: "64vh",
                          borderRadius: "8px",
                          objectFit: "cover",
                        }}
                      />
                    </Box>

                    {/* Contact Information Section */}
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                        alignItems: { xs: "center", sm: "start" },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          flex: 1,
                          mb: 2,
                          padding: "16px",
                          borderRadius: "8px",
                          backgroundColor: "#F1F7FA",
                          textAlign: "center",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            alignitems: "center",
                            alignContent: "center",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <img src={questionIcon} width={20} />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1rem",
                            color: "#2A4876",
                            marginBottom: "16px",
                          }}
                        >
                          Have a Question? Find quick answers here!
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          href="https://www.elevateaviation.ca/starters/echo/"
                          target="_blank"
                          sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            backgroundColor: "#2A4876",
                            "&:hover": {
                              backgroundColor: "#1E355E",
                            },
                          }}
                        >
                          FAQ
                        </Button>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          flex: 1,
                          mb: 2,
                          padding: "16px",
                          borderRadius: "8px",
                          backgroundColor: "#F1F7FA",
                          textAlign: "center",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            alignitems: "center",
                            alignContent: "center",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <img src={messageicon} width={20} />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1rem",
                            color: "#2A4876",
                            marginBottom: "16px",
                          }}
                        >
                          echo@elevateaviation.ca
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          href="https://www.elevateaviation.ca/starters/echo/#echo-form"
                          target="_blank"
                          sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            backgroundColor: "#2A4876",
                            "&:hover": {
                              backgroundColor: "#1E355E",
                            },
                          }}
                        >
                          Contact Us
                        </Button>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          flex: 1,
                          padding: "16px",
                          borderRadius: "8px",
                          backgroundColor: "#F1F7FA",
                          textAlign: "center",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "white",
                          }}
                        >
                          <BugReportOutlinedIcon
                            sx={{ color: "#2A4876", fontSize: 24 }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "1rem",
                            color: "#2A4876",
                            marginBottom: "16px",
                          }}
                        >
                          Found a bug? Let us know!
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          href="https://docs.google.com/forms/d/e/1FAIpQLScVUrNz70Rtngqomw3zSrSXT16fW8auNLSabpWX2v12JP3j3A/viewform"
                          target="_blank"
                          sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            backgroundColor: "#2A4876",
                            "&:hover": {
                              backgroundColor: "#1E355E",
                            },
                          }}
                        >
                          Report a Bug
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Background>
      <DashboardFooter />
    </>
  );
}

export default HelpandSupport;
